export const CARSA_NET_BASE_URL = "https://www.carsanet.co.uk";
export const DEFAULT_REDIRECT_URL = CARSA_NET_BASE_URL;
export const ESCALATE_VALUATION_ENDPOINT = "/valuations/escalate";
export const MILLISECONDS_IN_A_SECOND = 1000;
export const SUBMIT_VALUATION_ENDPOINT = "/valuations/complete";
export const VALUATION_ENDPOINT = "/vehicle-single-valuation";
export const VEHICLE_DETAILS_ENDPOINT = "/vehicle-details-check";
